<template>
    <el-container>
        <el-main>
            <el-row>
                <el-col>
                    <td-button type="primary" @click="addNetworkBtn" :permissions="permissions.addNetwork">{{ $t('pgCommon.ADD_NETWORK') }}</td-button>
                    <td-button @click="editNetworkBtn" :permissions="permissions.editNetwork">{{ $t('pgCommon.EDIT_NETWORK') }}</td-button>
                    <td-button @click="deleteNetworkBtn" :loading="deleteNetworkBtnLoading" :permissions="permissions.deleteNetwork">{{ $t('pgCommon.DELETE_NETWORK') }}</td-button>
                </el-col>
            </el-row>
            <el-row id="table">
                <el-col>
                    <td-table
                        ref="tableMain"
                        :columns="columnsMain"
                        :dataSource="tableDataMain"
                        :hasLoading="tableMainLoading"
                        :hasPage="false"
                        :max-height="tableHeigth"
                        :hasMutiSelect="false"
                        @row-click="rowClick"
                    ></td-table>
                </el-col>
            </el-row>
            <el-row>
                <el-col>
                    <td-table
                        ref="tableBranch"
                        :columns="columnsBranch"
                        :dataSource="tableDataBranch"
                        :hasLoading="tableBranchLoading"
                        :hasPage="false"
                        :max-height="tableHeigth"
                        :hasMutiSelect="false"
                    ></td-table>
                </el-col>
            </el-row>
        </el-main>
        <addNetwork
            :title="title"
            v-if="dialogNetworkVisible"
            :dialogVisible="dialogNetworkVisible"
            :networkForm="networkForm"
            :addOrEdit="addOrEdit"
            @dialogClose="dialogClose"
            @refreshData="listNetworkSettings"
        ></addNetwork>
        <addNetworkService
            :title="title"
            v-if="dialogNetworkServiceVisible"
            :dialogVisible="dialogNetworkServiceVisible"
            :networkServiceForm="networkServiceForm"
            :addOrEdit="addOrEdit"
            :sExtendInfo="sExtendInfo"
            @dialogClose="dialogClose"
            @refreshData="listNetworkServiceBySttingsId"
        ></addNetworkService>
    </el-container>
</template>

<script>
import addNetwork from './assets/dialogAddNetwork';
import addNetworkService from './assets/dialogAddNetworkService';
import api from './assets/api.js';
export default {
    // 初始化渲染
    components: {
        addNetwork,
        addNetworkService
    },
    created() {
        this.listNetworkSettings();
    },
    mounted() {
        this.initTableHeight();
    },
    data() {
        return {
            permissions: {
                addNetwork: ['networkSetting:addNetwork'],
                editNetwork: ['networkSetting:editNetwork'],
                deleteNetwork: ['networkSetting:deleteNetwork'],
                addNetworkService: ['networkSetting:addNetworkService'],
                editNetworkService: ['networkSetting:editNetworkService'],
                deleteNetworkService: ['networkSetting:deleteNetworkService']
            },
            title: '',
            dialogNetworkVisible: false,
            dialogNetworkServiceVisible: false,
            networkForm: { sName: '', sAddress: '' },
            networkServiceForm: { sType: 'networkServiceTypeRabbitMQ', sName: '', sIp: '', sMappingIp: '', sExtendInfo: {}, sNetworkSettingId: '' },
            sExtendInfo: {},
            tableDataMain: [],
            tableDataBranch: [],
            row: '',
            addOrEdit: '',
            tableMainLoading: false,
            tableBranchLoading: false,
            deleteNetworkBtnLoading: false,
            tableHeigth: '',
            columnsMain: [
                {
                    label: 'pgCommon.NETWORK_NAME',
                    prop: 'sName',
                    showOverflowTooltip: true
                },
                {
                    label: 'pgCommon.FLATFORM_IP',
                    prop: 'sAddress',
                    showOverflowTooltip: true
                },
                {
                    label: 'common.OPERATE',
                    align: 'center',
                    tableWidth: '200',
                    render: (createElement, params) => {
                        let addNetworkServiceBtn = createElement(
                            'td-button',
                            {
                                props: { type: 'text', size: 'small', permissions: this.permissions.deleteNetworkService },
                                on: {
                                    click: () => {
                                        this.addNetworkServiceBtn(params.row);
                                    }
                                }
                            },
                            this.$t('pgCommon.ADD_NETWORK_SERVICE')
                        );
                        return createElement('div', [addNetworkServiceBtn]);
                    }
                }
            ],
            columnsBranch: [
                {
                    label: 'pgCommon.SERVICE_TYPE',
                    prop: 'sTypeName',
                    tableWidth: '200'
                },
                {
                    label: 'pgCommon.SERVICE_NAME',
                    prop: 'sName',
                    showOverflowTooltip: true
                },
                {
                    label: 'pgCommon.SERVICE_IP',
                    prop: 'sIp',
                    tableWidth: '200'
                },
                {
                    label: 'pgCommon.MAPPING_IP',
                    prop: 'sMappingIp',
                    tableWidth: '200'
                },
                {
                    label: 'common.OPERATE',
                    align: 'center',
                    tableWidth: '200',
                    render: (createElement, params) => {
                        let editBtn = createElement(
                            'td-button',
                            {
                                props: { type: 'text', size: 'small', permissions: this.permissions.editNetworkService },
                                on: {
                                    click: () => {
                                        this.editBtn(params.row);
                                    }
                                }
                            },
                            this.$t('common.EDIT')
                        );
                        let deleteBtn = createElement(
                            'td-button',
                            {
                                props: { type: 'text', size: 'small', permissions: this.permissions.addNetworkService },
                                on: {
                                    click: () => {
                                        this.deleteBtn(params.row);
                                    }
                                }
                            },
                            this.$t('common.DELETE')
                        );
                        return createElement('div', [editBtn, deleteBtn]);
                    }
                }
            ]
        };
    },
    methods: {
        /**添加网络按钮触发方法 */
        addNetworkBtn() {
            this.title = this.$t('pgCommon.ADD_NETWORK');
            this.addOrEdit = 'add';
            this.dialogNetworkVisible = true;
        },
        /**编辑网络按钮触发方法 */
        editNetworkBtn() {
            if (this.row == '') {
                this.$message({ showClose: true, message: this.$t('pgError.ERROR_UPDATE_NETWORK'), type: 'warning' });
                return;
            }
            this.title = this.$t('pgCommon.EDIT_NETWORK');
            this.addOrEdit = 'edit';
            this.dialogNetworkVisible = true;
            this.networkForm = this.row;
        },
        /**删除网络按钮触发方法 */
        deleteNetworkBtn() {
            if (this.row == '') {
                this.$message({ showClose: true, message: this.$t('pgError.ERROR_DELETE_NETWORK'), type: 'warning' });
                return;
            }
            this.$confirm(this.$t('common.DELETE_INFO_TIPS'), this.$t('common.TIPS'), {
                confirmButtonText: this.$t('common.SURE'),
                cancelButtonText: this.$t('common.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    this.deleteNetworkSettings();
                })
                .catch(() => {});
        },
        /**删除网络设置 */
        deleteNetworkSettings() {
            let params = { sId: this.row.sId };
            this.deleteNetworkBtnLoading = true;
            api.deleteNetworkSettingsById(params, response => {
                this.deleteNetworkBtnLoading = false;
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('/networkSetting/deleteNetworkSettingsById', response);
                    return;
                }
                this.$message({ showClose: true, message: response.data.statusMessage, type: 'success' });
                this.row = '';
                this.listNetworkSettings();
                this.tableDataBranch = [];
            });
        },
        /**添加网络服务按钮触发方法 */
        addNetworkServiceBtn(row) {
            this.addOrEdit = 'add';
            this.title = this.$t('pgCommon.ADD_NETWORK_SERVICE');
            this.networkServiceForm.sNetworkSettingId = row.sId;
            this.dialogNetworkServiceVisible = true;
        },
        /**编辑按钮触发方法 */
        editBtn(row) {
            this.addOrEdit = 'edit';
            this.title = this.$t('pgCommon.EDIT_NETWORK_SERVICE');
            this.networkServiceForm = this.$util.clone(row);
            this.sExtendInfo = row.sExtendInfo == '' ? {} : JSON.parse(row.sExtendInfo);
            this.dialogNetworkServiceVisible = true;
        },
        /**删除按钮触发方法 */
        deleteBtn(row) {
            this.$confirm(this.$t('common.DELETE_INFO_TIPS'), this.$t('common.TIPS'), {
                confirmButtonText: this.$t('common.SURE'),
                cancelButtonText: this.$t('common.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    this.deleteService(row);
                })
                .catch(() => {});
        },
        /**删除网络服务 */
        deleteService(row) {
            let params = { sId: row.sId };
            this.tableBranchLoading = true;
            api.deleteNetworkServiceById(params, response => {
                this.tableBranchLoading = false;
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('/networkSetting/listNetworkServiceBySttingsId', response);
                    return;
                }
                this.$message({ showClose: true, message: response.data.statusMessage, type: 'success' });
                this.listNetworkServiceBySttingsId();
            });
        },
        /**关闭dialog触发的方法 */
        dialogClose() {
            this.dialogNetworkVisible = false;
            this.dialogNetworkServiceVisible = false;
            this.networkForm = { sName: '', sAddress: '' };
            this.networkServiceForm = { sType: 'networkServiceTypeRabbitMQ', sName: '', sIp: '', sMappingIp: '', sExtendInfo: {}, sNetworkSettingId: '' };
            this.sExtendInfo = {};
        },
        /**网络列表点击行信息触发 */
        rowClick(row) {
            this.row = this.$util.clone(row);
            this.listNetworkServiceBySttingsId();
        },
        /**根据网络设置sId查询网络服务信息 */
        listNetworkServiceBySttingsId() {
            let params = { sNetworkSettingId: this.row.sId };
            this.tableBranchLoading = true;
            api.listNetworkServiceBySttingsId(params, response => {
                this.tableBranchLoading = false;
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('/networkSetting/listNetworkServiceBySttingsId', response);
                    return;
                }
                this.tableDataBranch = response.data.content;
            });
        },
        /**加载table高度 */
        initTableHeight() {
            let table = document.getElementById('table');
            this.tableHeigth = (document.documentElement.clientHeight - table.offsetTop - 40) / 2;
        },
        /**获取所有网络信息（主表格数据） */
        listNetworkSettings() {
            this.tableMainLoading = true;
            api.listNetworkSettings(null, response => {
                this.tableMainLoading = false;
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('/networkSetting/listNetworkSettings', response);
                    return;
                }
                this.tableDataMain = response.data.content;
            });
        }
    }
};
</script>

<style></style>
